<template>
    <div class="wrap">
        <car-headerbar title="预览问卷模板" :isCustomLeft="isCustomLeft"/>
        <div class="content" :class="{addPadding}">
            <div class="question-header">
                <div class="title">{{question.pageTempName}}</div>
                <div class="comment" v-if="question.pageTempComment">
                    <me-field
                        v-model="question.pageTempComment"
                        autosize
                        disabled
                        type="textarea"
                        />
                </div>
            </div>
            <CarsForm
                class="form"
                ref="demoDynamicForm"
                :configData="configData"
                :model="model"
                v-on:[eventName]="eventHandler"
                v-if="isRunning"
                @addEventListenerForInput="addEventListenerForInput"
                @removeEventListenerForInput="removeEventListenerForInput"
            >
            </CarsForm>
            <img :src="logos[footer]" class="copyright" v-if="isRunning">
            <div class="dynamic-form-container">
                <div class="dynamic-form-footer">
                    <div safe-area-inset-bottom class="form_submit">
                        <me-button type="primary" block @click="useTemplate">基于此模板创建问卷</me-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Toast } from '@guazi-fe/melon'
import CarsForm from 'imc-mobile/src/component/form'
import { Questionnaire } from '@/network'
import { ENV } from '@/network/instance/generator'
import { baseUrls } from '@/network/config/service-baseurl'
import { mixin } from '@/mixins'
// import { off as offStatus } from '@/util/status-util'
import browser from '@/util/browser'
import { addClass2, removeClass2 } from '@/util/status-util'
const eim = require('../../images/copyright.png')
const chehaoduo = require('../../images/chehaoduo.png')

export default {
    name: 'dynamicForm',
    data() {
        return {
            eventName: 'submitAction',
            eventHandler: this.goEditPage,
            question: {},
            topicsList: [],
            model: {

            },
            BASEURL: baseUrls.plat[ENV], // network 拿到的环境变量
            logos: { eim, chehaoduo },
            footer: 'eim',
            isRunning: false,
            addPadding: false,
            isCustomLeft: false,
        }
    },
    mixins: [mixin],
    components: {
        CarsForm,
    },
    created() {
        // offStatus('loading')
        this.getRuntimeIndex()
        // setTimeout(()=>{
        //     $CA.util.NativeAPI.invoke('hiddenCloseBtn',{"hiddenClose":"1"})
        // })
        const { guaguaApp } = browser
        this.isCustomLeft = guaguaApp
    },
    computed: {
        pageId() {
            return this.$route.params.pageId
        },
        configData() {
            /**
             * hide: [{hideTopicIndex: 需要隐藏的题目的索引，value: 值为当前题的指定选项值或任何值}]
             */
            this.topicsList.forEach((item, index) => {
                let { skipValue, skipTarget } = item.skipJson || {}
                if (!skipValue) return
                if (skipValue === '0') {
                    // 无条件
                    if (skipTarget) {
                        const newSkipTo = this.topicsList.findIndex(item => item.topicCode === skipTarget)
                        const targetIndex = skipTarget === 'end' ? this.topicsList.length : newSkipTo // 目标题索引
                        for(let i=index+1; i<targetIndex; i++) {
                            const hide = this.topicsList[i].hide || []
                            const obj = Object.assign({}, this.topicsList[i], {hide:[{hideTopicIndex: index, skipValue: '0'},...hide]})
                            this.topicsList.splice(i, 1, obj)
                        }
                    }
                    return
                }
                if (skipValue === '1') {
                    // 按选项
                    item.selectItem.forEach((option) => {
                        let { skipTarget } = option
                        if (skipTarget) {
                            const newSkipTo = this.topicsList.findIndex(item => item.topicCode === skipTarget)
                            const targetIndex = skipTarget === 'end' ? this.topicsList.length : newSkipTo // 目标题
                            for(let i=index+1; i<targetIndex; i++) {
                                const hide = this.topicsList[i].hide || []
                                const obj = Object.assign({}, this.topicsList[i], {hide:[{hideTopicIndex: index, value: option.itemValue, skipValue: '1'},...hide]})
                                this.topicsList.splice(i, 1, obj)
                            }
                        }
                    })
                }
            })
            let time = 0
            let newTopicsList = this.topicsList.map((item, index) => {
                let newIndex = 0
                if (item.topicType == 'paragraph') {
                    time += 1
                }
                newIndex = index - time
                return { ...item, newIndex: newIndex }
            })
            let topicIndex = null
            const groupData = newTopicsList.map((item, index) => {
                const name = item.topicType == 'paragraph' ? '' : (`${item.newIndex + 1}.${item.topicName}`)
                const showJson = item.showJson ? JSON.parse(item.showJson) : null
                let topic = null
                showJson && showJson.list && showJson.list.forEach((obj, objIndex) => {
                    topicIndex = this.topicsList.findIndex(topic => topic.topicCode === obj.id)
                    topic = this.topicsList.find(topic => topic.topicCode === obj.id)
                    if (/^(radio|checkbox)$/.test(topic.topicType)) {
                        obj.conditions.forEach((condition, i) => {
                            topic.selectItem[condition] ? null : obj.conditions.splice(i, 1, '')
                        })
                        obj.conditions = obj.conditions.filter(item => item)
                        if (!obj.conditions.length) {
                            showJson.list.splice(objIndex, 1, '')
                            return
                        }
                    }
                    obj.showIndex = topicIndex > -1 ? topicIndex : null
                })
                showJson && showJson.list ? showJson.list = showJson.list.filter(item => item) : null
                let data = {
                    code: item.topicId,
                    label: name,
                    type: item.topicType == 'paragraph' ? 'textarea' : (item.topicType === 'textarea' && item.inputSize === '1' ? 'text' : item.topicType),
                    rules: [{ required: item.required, message: `请填写${item.topicName}` }],
                    placeholder: '请输入',
                    shape: 'round',
                    props: {
                        autosize: true,
                        readonly: false,
                        placeholder: 'placeholder',
                        shape: 'round',
                    },
                    hide: item.hide,
                    showJson: showJson,
                }
                if (item.topicType == 'textarea' && item.inputSize) {
                    data.props.rows = parseInt(item.inputSize || 1)
                }
                if (item.topicType == 'paragraph') {
                    data.value = item.commonNote
                    data.rules = [{ required: false }]
                }
                if (/^(radio|checkbox|matrix-rate)$/.test(item.topicType)) {
                    let option_list = item.selectItem && item.selectItem.map((cur) => {
                        const parsedChildrenData = this.parseChildrenData(cur.childrenData)
                        const childrenData = parsedChildrenData || (cur.subOption || cur.SubOption ? {
                            subOption: cur.subOption || cur.SubOption || [],
                            subOptionLeastChoose: cur.subOptionLeastChoose || cur.SubOptionLeastChoose || '不限制',
                            subOptionMostChoose: cur.subOptionMostChoose || cur.SubOptionMostChoose || '不限制',
                        } : null)
                        const data = {
                            label: cur.itemKey,
                            value: cur.itemValue,
                            childrenData,
                        }
                        let optionImg = {}
                        let isRadioOrCheckbox = /^(radio|checkbox)$/.test(item.topicType)
                        if (isRadioOrCheckbox) {
                            optionImg.thumbViewUrl = cur.thumbViewUrl
                            optionImg.itemUrl = cur.itemUrl
                        }
                        if (cur.itemIndex == '10000') {
                            data.slot = {
                                code: 'otherValue',
                                component: 'me-field',
                                // label: '输入框',
                                type: 'text',
                                placeholder: '请输入',
                                // rules: [{ required: true, message: '请填写详细信息' }],
                                props: {
                                    readonly: false,
                                },

                            }
                        }

                        return isRadioOrCheckbox ? {...data, ...optionImg} : data
                    })

                    data.option_list = option_list
                    data.props = {
                        max: item.mostChoose,
                        min: item.leastChoose,
                        shape: item.topicType == 'radio' ? 'round' : '',
                    }
                    // 若选择了1、2、3、4中的任何一个，则标题处显示【最少选择x项/最多选择x项/请选择1-4个选项
                    let rightText
                    if (item.leastChoose !== '不限制' && item.mostChoose !== '不限制') {
                        rightText = item.leastChoose === item.mostChoose ? `【请选择${item.leastChoose}项】` : `【请选择${item.leastChoose}-${item.mostChoose}项】`
                    } else if (item.leastChoose !== '不限制') {
                        rightText = `【至少选择${item.leastChoose}项】`
                    } else if (item.mostChoose !== '不限制') {
                        rightText = `【至多选择${item.mostChoose}项】`
                    }
                    if (item.topicType == 'radio') {
                        data.itemProps = {
                            rightIcon: {
                                component: 'me-tag',
                                text: '单选',
                                tips: '',
                                props: {
                                    type: 'success',
                                    plain: true,
                                    size: 'medium',
                                },
                            },
                        }
                    } else if (item.topicType == 'checkbox') {
                        const itemProps = {
                            rightIcon: {
                                component: 'me-tag',
                                text: '多选',
                                tips: rightText,
                                props: {
                                    type: 'success',
                                    plain: true,
                                    size: 'medium',
                                },
                            },
                        }
                        if (item.labelStyle === '1') {
                            itemProps.class = 'label-style-checkbox'
                        }
                        data.itemProps = itemProps
                    }
                    if (item.topicType === 'checkbox' && item.labelStyle === '1') {
                        data.props = {
                            ...data.props,
                            shape: '',
                        }
                    }

                }
                if (item.topicType == 'paragraph') {
                    data.props.readonly = true
                }
                if (/^(rate|matrix-rate)$/.test(item.topicType)) {
                    data.props.count = item.score
                }
                if (/^(rate|nps)$/.test(item.topicType)) {
                    data.labelJson = item.labelJson
                }
                return data
            })
            // 以上可以抽取

            return {
                form: {
                    // button: { disabled: false, text: '返回编辑页面' },
                    button: false,
                    groupData,
                },
                api: {
                    request: {
                        submit: {
                            url: `${this.BASEURL}/questionpage/runtime/save`,
                            method: 'post',
                        },
                    },
                },
            }
        },
    },
    methods: {
        // 移动端输入时键盘弹起
        addEventListenerForInput() {
            const isAndroid = /android/i.test(window.navigator.userAgent)
            isAndroid ? this.addPadding = true : null
        },
        removeEventListenerForInput() {
            const isAndroid = /android/i.test(window.navigator.userAgent)
            isAndroid ? this.addPadding = false : null
        },
        getRuntimeIndex() {
            addClass2('body', 'loading')
            // question：调查问卷；form：审批表单；
            const data = {
                tid: this.tid,
                pageTempId: this.pageId,
            }
            Questionnaire.getTemplateDetail(data).then((res) => {
                removeClass2('body', 'loading')
                if (res.data.code == 'S00000') {
                    this.isRunning = true
                    this.question = res.data.data
                    this.footer = this.question.footer || 'eim'
                    this.question.pageComment = this.question.pageTempComment.replace(/↵/g, '<br>')
                    this.topicsList = this.question.topicsList
                }
            }).catch((error) => {
                removeClass2('body', 'loading')
                this.isRunning = false
                console.log(error.response)
                Toast.fail(error.response.data.message)
            })
        },
        useTemplate() {
            // const { guaguaApp } = browser
            this.$store.commit('removeRangeList')
            this.$store.commit('updateLabelNames', [])
            this.$store.commit('removeTemplateData')
            const params = {
                tid: this.tid,
                pageTempId: this.pageId
            }
            Questionnaire.useTemplate(params).then(res => {
                const { data: { data } } = res
                this.$router.push({
                    name: 'edit',
                    params: {
                        pageId: data,
                    },
                })
            })

            // if (guaguaApp) {
            //     $CA.util.NativeAPI.invoke('closeCurrentWebView', null, () => {})
            // } else {
            //     this.$router.go(-1)
            // }
        },
        submitSuccess() {
            console.log('答题成功')
        },
        parseChildrenData(data) {
            if (!data) return null
            if (typeof data === 'object') return data
            if (typeof data === 'string') {
                try {
                    return JSON.parse(data)
                } catch (error) {
                    console.warn('parse childrenData error', error)
                    return null
                }
            }
            return null
        },

    },
}
</script>
<style lang="scss" scoped>
    .addPadding {
        padding-bottom: 400PX!important;
    }
    .wrap{
        position: relative;
        // background: #F2F4F6;
        height: 100%;
        // height: calc(100% - 50px);
        .content{
            padding: 12px;
            padding-bottom: 4.5rem;
            position: relative;
            min-height: calc(100% - 1.2rem - .32rem - 4.5rem);
            // overflow-y: scroll;
            // height: calc(100% - 80px);
        }
    }
    ::v-deep .me-cell--clickable:active {
        background-color: #fff;
    }
    ::v-deep .comment{
        textarea{
            font-size: 14px;
        }
    }
    ::v-deep .dynamic-form-container{
        padding: 0;
        // background: #fff;
        .dynamic-form-fielditem::after{
            border: none;
        }
        .dynamic-form-fielditem{
            border-radius: 6px;
            margin-bottom: 12px;
            overflow: hidden;
            .me-field__label{
                padding: 12px 0;
                margin-bottom: 0;
            }
            .me-cell--required::before{
                top: 25px;
                left: 8px;
            }
            .me-checkbox-group{
                width: 100%;
                span .me-cell{
                    line-height: 48px;
                    padding: 0 12px;
                    margin-top: 16px;
                }
            }
            .me-radio-group {
                width: 100%;
                .me-radio {
                    width: 100%;
                }
                .me-radio__label{
                    width: 100%;
                }
            }
            .me-radio__label{
                display: flex;
                align-items: center;
                // .me-radio__label,span{
                //     min-width: 30px;
                // }
                > div:first-child {
                    align-items: center !important;
                    width: 100%;
                    justify-content: space-between;
                }
                > div > span:first-child{
                    min-width: 30px;
                    flex: 1;
                    + span {
                        width: 200px;
                    }
                }
                .me-cell{
                    min-height: 24px;
                    line-height: 24px;
                    padding: 0 12px;
                }
            }
            .me-cell{
              min-height: 52px;
              line-height: 24px;
            }
            .me-cell__title{
                font-size: 14px;
                font-weight: bold;
                color:#222;
                line-height: 26px;
                // overflow : hidden;
                // text-overflow: ellipsis;
                // display: -webkit-box;
                // -webkit-line-clamp: 2;
                // -webkit-box-orient: vertical;
                padding: 0;
                padding-right: 20px;
                margin: 12px 0 0;
            }
            .me-cell__value--alone {
                textarea[readonly="readonly"]{
                    padding-left: 0;
                    background: #fff;
                    color: #9298A8;
                    font-size: 14px;
                    margin-bottom: 0;
                    line-height: 24px;
                }
            }
            .me-field__body{
                input,textarea {
                    background: #F6F6F6;
                    line-height: 36px;
                    border-radius: 6px;
                    padding-left: 16px ;
                }
                .me-field__control--custom {
                    // .me-checkbox__label{
                    //     min-width: 30px;
                    // }
                    .me-checkbox {
                        flex: 1;
                        + span {
                            width: 200px;
                        }
                    }
                    >div {
                        >div {
                            padding: 12px 0;
                            align-items: center!important;
                            justify-content: space-between;
                            width: 100%;
                        }
                    }
                }
            }
            // 处理错误信息显示距离问题
            .me-field__body + .van-field__error-message{
                margin-top: 10px;
            }
            .me-field--min-height .me-field__control{
                min-height: 36px;
            }
        }
        .dynamic-form-footer{
            .me-button--primary{
                background: #06B455;
            }
        }
        .label-style-checkbox {
            .checkbox-wrap {
                width: auto !important;
                padding: 0 !important;
            }
            .me-checkbox-group {
                display: flex;
                flex-wrap: wrap;
                gap: 12px 12px;
            }
            .me-checkbox {
                background: #F2F4F6;
                border-radius: 4px;
                padding: 10px 16px;
                font-family: PingFangSC, 'PingFang SC', sans-serif;
                font-weight: 400;
                font-size: 14px;
                color: #424B58;
                margin-right: 0;
                border: none;
                display: inline-flex;
                align-items: center;
            }
            .me-checkbox__icon {
                display: none;
            }
            .me-checkbox__label {
                width: auto;
                margin: 0 !important;
                text-align: center;
            }
            .me-checkbox[aria-checked="true"] {
                background: #05B555;
                color: #FFFFFF;
            }
            .me-checkbox[aria-checked="true"] .me-checkbox__label {
                color: #FFFFFF;
            }
        }
    }
    .copyright{
        display: block;
        margin: 38px auto 0;
        width: 4.56rem;
        height: auto;
        position: absolute;
        bottom: 2.66667rem;
        left: 50%;
        transform: translateX(-50%);
    }
</style>
